import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { TaskRoutes } from '@/modules/to/task/task.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/tasks',
      name: TaskRoutes.TASKS,
      component: () => import(/* webpackChunkName: "task-page" */ './pages/TaskPage.vue'),
    },
  ],
  Module.TASK
);
